// Global Types
import type {
  $Component,
} from 'common.types';

// Global Enums
import {
  RatingType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Label,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Helpers
import _ from 'lodash';

type $Props = {
  activeRatingType: RatingType;
  values: Record<string, unknown>;
};

const InputRatingView = ({
  activeRatingType,
  values,
}: $Props): $Component<unknown> => {
  const getValue = (key: string): string | undefined => {
    const value: undefined | unknown = _.get(
      values,
      key,
    );

    if (value) {
      return String(value);
    }

    return undefined;
  };

  const ratingFields: Record<RatingType, $Component<unknown>> = {
    [RatingType.irc]: (
      <Row>
        <Col>
          <AvField
            label={'GPH'}
            name={'Values.GPH'}
            required
            value={getValue('GPH')}
          />
        </Col>
      </Row>
    ),
    [RatingType.lkrth]: (
      <Row>
        <Col>
          <AvField
            label={'GPH'}
            name={'Values.GPH'}
            required
            value={getValue('GPH')}
          />
        </Col>
      </Row>
    ),
    [RatingType.lys]: (
      <Row>
        <Col>
          <AvField
            label={'GPH'}
            name={'Values.GPH'}
            required
            value={getValue('GPH')}
          />
        </Col>
      </Row>
    ),
    [RatingType.monotype]: <div />,
    [RatingType.orc]: (
      <>
        <Row>
          <Col>
            <AvField
              label={'GPH'}
              name={'Values.GPH'}
              required
              value={getValue('GPH')}
            />
          </Col>
          <Col>
            <AvField
              label={'CDL'}
              name={'Values.CDL'}
              required
              value={getValue('CDL')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Label>{'Costal / Long Distance'}</Label>
          </Col>
          <Col>
            <Label>{'Leeward / Windward'}</Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row className={'no-gutters'}>
              <Col>
                <AvField
                  label={'ToD'}
                  name={'Values.OSN'}
                  required
                  value={getValue('OSN')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToT'}
                  name={'Values.TMF_Offshore'}
                  required
                  value={getValue('TMF_Offshore')}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row className={'no-gutters'}>
              <Col>
                <AvField
                  label={'ToD'}
                  name={'Values.ILCWA'}
                  required
                  value={getValue('ILCWA')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToT'}
                  name={'Values.TMF_Inshore'}
                  required
                  value={getValue('TMF_Inshore')}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <Label>{'Triple number'}</Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row className={'no-gutters'}>
              <Col>
                <AvField
                  label={'ToD Low'}
                  name={'Values.TND_Offshore_Low'}
                  required
                  value={getValue('TND_Offshore_Low')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToD Mid'}
                  name={'Values.TND_Offshore_Medium'}
                  required
                  value={getValue('TND_Offshore_Medium')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToD High'}
                  name={'Values.TND_Offshore_High'}
                  required
                  value={getValue('TND_Offshore_High')}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row className={'no-gutters'}>
              <Col>
                <AvField
                  label={'ToD Low'}
                  name={'Values.TND_Inshore_Low'}
                  required
                  value={getValue('TND_Inshore_Low')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToD Mid'}
                  name={'Values.TND_Inshore_Medium'}
                  required
                  value={getValue('TND_Inshore_Medium')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToD High'}
                  name={'Values.TND_Inshore_High'}
                  required
                  value={getValue('TND_Inshore_High')}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row className={'no-gutters'}>
              <Col>
                <AvField
                  label={'ToT Low'}
                  name={'Values.TN_Offshore_Low'}
                  required
                  value={getValue('TN_Offshore_Low')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToT Mid'}
                  name={'Values.TN_Offshore_Medium'}
                  required
                  value={getValue('TN_Offshore_Medium')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToT High'}
                  name={'Values.TN_Offshore_High'}
                  required
                  value={getValue('TN_Offshore_High')}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row className={'no-gutters'}>
              <Col>
                <AvField
                  label={'ToT Low'}
                  name={'Values.TN_Inshore_Low'}
                  required
                  value={getValue('TN_Inshore_Low')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToT Mid'}
                  name={'Values.TN_Inshore_Medium'}
                  required
                  value={getValue('TN_Inshore_Medium')}
                />
              </Col>
              <Col>
                <AvField
                  label={'ToT High'}
                  name={'Values.TN_Inshore_High'}
                  required
                  value={getValue('TN_Inshore_High')}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    ),
    [RatingType.vjdh]: (
      <Row>
        <Col>
          <AvField
            label={'GPH'}
            name={'Values.GPH'}
            required
            value={getValue('GPH')}
          />
        </Col>
      </Row>
    ),
  };

  return ratingFields[activeRatingType];
};

export default InputRatingView;
